function Environment() {
    return {
        current: () => {
            return ENV;
        },

        isLocal: function () {
            return this.current() === 'dev';
        },

        isStaging: function () {
            return this.current() === 'staging';
        },

        isProduction: function () {
            return this.current() === 'production';
        }
    }
}